import { FormInput, Title } from "components";
import { RemoveTimeFromDate } from "helpers/data/dataHandling";
import { useEffect, useRef, useState } from "react";
import { Card, Col, Form, Nav, Row, Tab } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { cleanCatalogueDetails, getCatalogueDetails, getOldCatalogueDetails, updateCatalogueField } from "redux/slices/Catalogues";
import { RootState } from "redux/store";
import OldStocks from "./OldStocks";
import OldStores from "./OldStores";

export function OldCatalogue() {
	const form = useRef(null);
	const navigate = useNavigate();
	const dispatch = useAppDispatch();
	const { catalogueId } = useParams();
	const [isNewCatalogue, setIsNewCatalogue] = useState<boolean>(true);
	const catalogue = useAppSelector((state: RootState) => state.catalogues);

	useEffect(() => {
		if (catalogueId && !isNaN(Number.parseInt(catalogueId))) {
			dispatch(getOldCatalogueDetails(
				{
					loadDetails: ["Stock", "Stores"],
					ids: [Number.parseInt(catalogueId)],
				})).then((res) => {
					handleChange("loadingStocks", false);
				});
			setIsNewCatalogue(false);
		} else {
			navigate("/app/catalogue/new");
			dispatch(cleanCatalogueDetails());
			setIsNewCatalogue(true);
		}
	}, [catalogueId]);



	function handleChange(option: any, optionValue: any) {
		dispatch(updateCatalogueField({ key: option, value: optionValue }));
	}


	return (
		<>
			<Title pageTitle={"View Catalogue"} crumbs={[{ name: "Catalogues", path: "/app/catalogues" }]} />
			<Row>
				<Col xs={12}>
					<Card>
						<Card.Body>
							<Row className="mb-1">
								<Col>
									<Form ref={form}>
										<Row>
											<h4 className="mt-2">Catalogue View Only Details - Migrate to enable editing</h4>
											<Col md={6}>
												<Col md={8}>
													<FormInput
														required
														label="Name"
														type="text"
														name="catalogue-name"
														placeholder="Enter catalogue name"
														containerClass={"mb-3"}
														value={catalogue.model.name}
														key="text"
														disabled={true}
													/>
												</Col>
											</Col>
											<Col md={6} className="d-flex flex-row-reverse">
												<Col md={4} className="ms-3">
													<FormInput
														min={catalogue.model.startDate ?? undefined}
														label="End Date"
														type="date"
														name="catalogue-end-date"
														placeholder="Enter catalogue end date"
														containerClass={"mb-3"}
														value={RemoveTimeFromDate(catalogue.model.endDate)}
														disabled={true}
													/>
												</Col>
												<Col md={4}>
													<FormInput
														max={catalogue.model.endDate ?? undefined}
														label="Start Date"
														type="date"
														name="catalogue-start-date"
														placeholder="Enter catalogue start date"
														containerClass={"mb-3"}
														value={RemoveTimeFromDate(catalogue.model.startDate)}
														disabled={true}
													/>
												</Col>
											</Col>
										</Row>
										<Row className="ms-0 me-0 mb-0" >
											<Col md={12}>
												<Tab.Container defaultActiveKey="1">
													<Row className="mb-1">
														<Nav id="stocks-nav" as="ul" variant="pills" className="nav nav-pills bg-nav-pills nav-justified mb-3">
															<Nav.Item as="li" className="nav-item">
																<Nav.Link href="#" eventKey="1" className="nav-link rounded-0">Stocks</Nav.Link>
															</Nav.Item>
															<Nav.Item as="li">
																<Nav.Link href="#" eventKey="2" className="nav-link rounded-0">Stores</Nav.Link>
															</Nav.Item>
														</Nav>
														<Row style={{ margin: "0px", padding: "0px" }}>
															<Col lg={12} style={{ padding: "0px 3px" }}>
																<Tab.Content>
																	<Tab.Pane eventKey="1">
																		<OldStocks />
																	</Tab.Pane>
																	<Tab.Pane eventKey="2">
																		<OldStores />
																	</Tab.Pane>
																</Tab.Content>
															</Col>
														</Row>
													</Row>
												</Tab.Container>
											</Col>
										</Row>
										<Row className="mt-2">
											<Col sm={6}>
												<Link to="/app/catalogues" className="btn text-muted d-none d-sm-inline-block btn-link fw-semibold" onClick={() => dispatch(cleanCatalogueDetails())}>
													<i className="mdi mdi-arrow-left"></i> Back to All Catalogues {" "}
												</Link>
											</Col>
											<Col sm={6} className="d-flex flex-row-reverse">
											</Col>
										</Row>
									</Form>
								</Col>
							</Row>
						</Card.Body>
					</Card>
				</Col>
			</Row>
		</>
	);
}